"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getDefaultSort = exports.SortOrder = void 0;
var _listingSortOrder = require("../../enums/listing-sort-order");
var _simpleSearchQueryField = require("../simple-search-query-field");
var _excluded = ["options"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var sortFromSortOrder = sortOrder => {
  var _ref = (sortOrder === null || sortOrder === void 0 ? void 0 : sortOrder.value.toUpperCase().split('-')) || [],
    _ref2 = _slicedToArray(_ref, 2),
    criteria = _ref2[0],
    order = _ref2[1];
  return {
    criteria,
    order
  };
};
var parseSort = (input, defaultSort) => {
  var _ref3 = typeof input === 'string' ? sortFromSortOrder((0, _listingSortOrder.sortOrderByValue)(input)) : input || {},
    criteria = _ref3.criteria,
    order = _ref3.order,
    options = _ref3.options;
  return {
    criteria: _listingSortOrder.SortFields.find(predicate => predicate.toUpperCase() === (criteria === null || criteria === void 0 ? void 0 : criteria.toUpperCase())) || defaultSort.criteria,
    order: _listingSortOrder.SortDirections.find(predicate => predicate.toUpperCase() === (order === null || order === void 0 ? void 0 : order.toUpperCase())) || defaultSort.order,
    options: options || defaultSort.options
  };
};
var getDefaultSort = sortOptions => {
  switch (sortOptions.searchType) {
    case 'new-price':
      return {
        criteria: 'UPDATED',
        order: 'DESC'
      };
    default:
      return {
        criteria: sortOptions.listingType === 'SALES_RESIDENTIAL' ? 'AUCTION' : 'PRICE',
        order: 'ASC'
      };
  }
};
exports.getDefaultSort = getDefaultSort;
class SortOrder extends _simpleSearchQueryField.SimpleSearchQueryField {
  constructor(searchOptions, value) {
    var defaultValue = getDefaultSort(searchOptions);
    super(searchOptions, parseSort(value, defaultValue), defaultValue);
    _defineProperty(this, "urlSlug", SortOrder.slug);
  }
  isDefault() {
    var _this$internalValue, _this$default, _this$internalValue2, _this$default2, _this$internalValue3, _this$default3;
    return ((_this$internalValue = this.internalValue) === null || _this$internalValue === void 0 ? void 0 : _this$internalValue.criteria) === ((_this$default = this.default) === null || _this$default === void 0 ? void 0 : _this$default.criteria) && ((_this$internalValue2 = this.internalValue) === null || _this$internalValue2 === void 0 ? void 0 : _this$internalValue2.order) === ((_this$default2 = this.default) === null || _this$default2 === void 0 ? void 0 : _this$default2.order) && ((_this$internalValue3 = this.internalValue) === null || _this$internalValue3 === void 0 ? void 0 : _this$internalValue3.options) === ((_this$default3 = this.default) === null || _this$default3 === void 0 ? void 0 : _this$default3.options);
  }
  getCondensedValue() {
    if (!this.internalValue) {
      return null;
    }
    var _this$internalValue4 = this.internalValue,
      options = _this$internalValue4.options,
      value = _objectWithoutProperties(_this$internalValue4, _excluded);
    return _objectSpread(_objectSpread({}, value), options ? {
      options
    } : {});
  }
  getUrlParameterValue() {
    var _sortOrderByValue;
    var sort = this.internalValue;
    var value = "".concat(sort.criteria).concat(sort.order && "-".concat(sort.order)).toLowerCase();
    return ((_sortOrderByValue = (0, _listingSortOrder.sortOrderByValue)(value)) === null || _sortOrderByValue === void 0 ? void 0 : _sortOrderByValue.urlSlug) || value;
  }
  static fromUrlParameters(searchOptions, q) {
    return new SortOrder(searchOptions, sortFromSortOrder((0, _listingSortOrder.sortOrderBySlug)(q[SortOrder.slug])));
  }
}
exports.SortOrder = SortOrder;
_defineProperty(SortOrder, "slug", 'sort');